/* eslint-disable */
import Vue from 'vue';
import moment from 'moment';
import lang from '@/lang';
import store from '@/store';

Vue.filter('translate', (value, scope) => lang.translate(value, scope));

/**
 * @param {String} date
 * @returns {Moment|null}
 */
function parseDate(value) {
  let date = moment(value);

  if (!date.isValid() || !date._f) return null;
  if (value.includes('+') && store.state.Scope.name !== 'LVMH') {
    date = moment(value.replace(/\+.+/, ''));
  }

  return date;
}

Vue.filter('datetime', (value, fallback) => {
  let date = value;

  if (!value) return fallback || 'N/A';
  date = parseDate(date);
  if (!date) return value;

  return lang.locale.includes('fr')
    ? date.format('DD.MM.YYYY - HH:mm')
    : date.format('YYYY.MM.DD - HH:mm');
});

Vue.filter('date', (value, fallback) => {
  let date = value;

  if (!value) return fallback || 'N/A';
  date = parseDate(date);
  if (!date) return value;

  return lang.locale.includes('fr')
    ? date.format('DD.MM.YYYY')
    : date.format('YYYY.MM.DD');
});

Vue.filter('time', (value, fallback) => {
  let date = value;

  if (!value) return fallback || 'N/A';
  date = parseDate(date);
  if (!date) return value;

  return date.format('HH:mm');;
});
